export function ConfirmFill(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM9.18843 3.3551C9.29265 3.06941 9.1656 2.74554 8.886 2.61013C8.58776 2.4657 8.22891 2.59038 8.08447 2.88861L5.5718 8.07683L5.54898 8.11564C5.47237 8.22462 5.32595 8.2652 5.20217 8.20525C5.17301 8.19113 5.14655 8.17199 5.12401 8.14872L3.82601 6.80845L3.778 6.76393C3.54546 6.57065 3.19976 6.57969 2.97759 6.79485C2.73955 7.02538 2.73346 7.40524 2.96399 7.64327L4.262 8.98355L4.33663 9.05539C4.43935 9.14754 4.55461 9.22496 4.67912 9.28526C5.41312 9.64074 6.29633 9.33389 6.65181 8.59988L9.16448 3.41166L9.18843 3.3551Z"
          fill="#DA2E9A"
        />
      </svg>
    </div>
  );
}
